<template>
  <div>
    <timer-component
      :time="time"
      :time_end="time_end"
      :time_destroy="1"
      classes="text-white-mob font-s18 py-lg-2 p-2 d-block text-center text-md-end fst-italic"
    />
  </div>
</template>

<script>
import TimerComponent from "../TimerComponent";

export default {
  name: 'LotComponent',
  components: {TimerComponent},
  props: ['time_end'],
  data: function () {
    return {
      time: 0,
    }
  },
  watch: {},
  mounted() {
    this.broadcast()
  },
  methods: {
    broadcast() {
      Echo.channel('time')
        .listen('update', (e) => {
          this.time = e.time
        })
    },
  }
}
</script>
